import React, { useEffect } from "react";
import { useState } from "react";
import HomeServices from "../Home/HomeServices";
import CompanyCertificationModal from "../Verify Certificate/CompanyCertificationModal";
import Instance from "../../AxiosConfig";

const CompanyCertification = () => {
  const [companyName, setCompanyName] = useState("");
  const [clientName,setClientName]=useState("");
  const [certificateNumber, setCertificateNumber] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(false);

 const handleSearch = async () => {
  setLoading(true);
  try {
    const response = await Instance.get(
      `Certification/search?companyName=${companyName}&certificationNumber=${certificateNumber}`
    );

    console.log("API Response:", response.data);

    if (response.status === 200 || response.status === 201) {
      const certData = response.data.certification;
      setCertificateData(certData);
      setTimeout(() => setShowModal(true), 100);
    } else {
      setCertificateData(null);
      setShowModal(true);
    }
  } catch (error) {
    console.error("Error fetching certificate:", error);
    setCertificateData(null);
    setShowModal(true);
  } finally {
    setLoading(false);
    setCertificateNumber("");
    setCompanyName("");
  }
};


  // remove handleSearch from useEffect or add conditional
  useEffect(() => {
    if (companyName && certificateNumber) {
      handleSearch();
    }
  }, []);

  const handleButtonClick = () => {
    if (!companyName || !certificateNumber) {
      alert("Please enter both Company Name and Certificate No");
      return;
    }
    handleSearch();
  };

  return (
    <>
      <div className="certificate-banner">
        <div className="certificate-banner-content">
          <h1>
            VERIFY YOUR CERTIFICATION <br />
            INSTANTLY AND SECURELY
          </h1>
          <p>
            VERIFY ANY ISO CERTIFICATE ISSUSED BY US TO CONFIRM ITS AUTHENTICITY
            AND <br />
            VALIDITY IN REAL TIME.
          </p>
          <button className="btn btn-outline-light rounded-pill pX-4 mt-3">
            Get Started
          </button>
        </div>
      </div>
      <div className="container verify-certificate">
        <form
          className="verify-certificate-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <h5 className="verify-title">VERIFY CERTIFICATE</h5>

          {/* Certificate No */}
          <div className="d-flex align-items-center mt-4 verify-certificate-companyno">
            <label className="verify-label">Certificate No :</label>
            <input
              type="text"
              className="verify-form-input"
              value={certificateNumber}
              onChange={(e) => setCertificateNumber(e.target.value)}
            />
          </div>

          {/* Company Name */}
          <div className="d-flex align-items-center mt-4 verify-certificate-company-name">
            <label className="verify-label">Company Name :</label>
            <input
              type="text"
              className="verify-form-input"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          </div>

          {/* Search Button */}
          <div className="d-flex justify-content-end mt-4">
            <button
              type="button"
              className="verify-btn"
              onClick={handleButtonClick}
              disabled={loading}
            >
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        </form>
      </div>

      <HomeServices />

      <CompanyCertificationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        data={certificateData}
        loading={loading}
      />
    </>
  );
};

export default CompanyCertification;
